import React, { useRef, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import DevicesStatusReports from './DevicesStatusReports';
import AccessControl from '../../AccessControl';
import permissions from '../../permissionsList';
import AuditLogReports from './auditReports/AuditLogReports.js';

export function UnconnectedReports(props) {
  const location = useLocation();
  const { state } = location;
  const previousLocation = useRef(location);

  useEffect(() => {
    // universal reports calls will go here
  }, []); // eslint-disable-line

  // this is for if/when we need to use modals in displaying reports
  // if (state && state.modal && history.action === 'POP') {
  //   if (
  //     pathname === '/units/addUnit/' ||
  //     pathname === '/units/export/' ||
  //     pathname === '/units/import/'
  //   ) {
  //     previousLocation.current = { pathname: '/units/' };
  //   }
  // }

  // useEffect(() => {
  //   if (location) {
  //     if (state && state.modal) {
  //       previousLocation.current = { pathname: '/units/' };
  //     } else {
  //       previousLocation.current = location;
  //     }
  //   }
  // }, [location, state]);

  let isModal = false;
  if (state && state.modal) {
    isModal = true;
  }

  return (
     <AccessControl
       data-test="access-control"
       feature={permissions.static.navBar.reports}
       permissionMessage={true}>
      <React.Fragment>
        {/* The Routes is used to set the background to display underneath the overlay component. It checks to see if the url being loaded involves a modal and uses the route found in the previousLocation ref to set the contents of the Routes */}
        <Routes location={isModal ? previousLocation.current : location}>
          <Route 
            path="devicesStatus/*"
            element={<DevicesStatusReports />}
            data-test="devicesStatus-route"
          />
          <Route 
            path="AuditLogReports"
            element={<AuditLogReports />}
          />
          <Route 
            path="/"
            element={<DevicesStatusReports />}
          />
        </Routes>
        {/* <Route
      path="/units/addUnit/"
      component={AddNewUnit}
      data-test="add-route"
    />
    */}
      </React.Fragment>
    </AccessControl>
  );
}
export default connect()(UnconnectedReports);
